module.exports = [{"type":"title","text":"2024-12-17"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：雙向持倉支持自動追加保證金"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-12-17.json
// module id = bLnD
// module chunks = 3